import { EventBus } from "@/bus";
import { displayErrors } from "utils/string"
import { safeNext, navigateToNext } from "utils/redirect"

export const tgLoginMixin = {
    mounted() {
        this.initTelegramWidget()
    },
    methods: {
        initTelegramWidget() {
            const script = document.createElement('script')
            script.src = 'https://telegram.org/js/telegram-widget.js?22'
            script.setAttribute('data-telegram-login', env.TG_BOT_NAME)
            script.setAttribute('data-size', 'large')
            script.setAttribute('data-radius', '8')
            script.setAttribute('data-request-access', 'write')
            script.setAttribute('data-onauth', 'onTelegramAuth(user)')
            script.async = true
            this.$refs.tgLoginWidget.appendChild(script)
            window.onTelegramAuth = (user) => this.handleTgLogin(user)
        },
        tgNextPath() {
            return safeNext(this.$route && this.$route.query && this.$route.query.next)
        },
        handleTgLogin(tgUser) {
            this.disabled = true
            this.errors = {}
            this.$services.TgLogin().save(tgUser).then(resp => {
                // tfa_required comes with state=false, so it must be checked
                // before the success branch (and before displayErrors below,
                // which would otherwise paint "Request failed" over it). This
                // mixin is also used by Registration.vue, which has no code
                // UI — send both to /login, keeping ?next= for OAuth consent.
                if (resp.body.message === 'tfa_required') {
                    this.disabled = false
                    const tfaNext = this.tgNextPath()
                    const query = {step: 'tfa'}
                    if (tfaNext) query.next = tfaNext
                    return this.$router.push({path: '/login', query})
                }
                if (resp.body.state) {
                    const next = this.tgNextPath()
                    if (resp.body.message === 'need_email') {
                        const target = {path: '/tg-complete'}
                        if (next) target.query = {next}
                        this.$router.push(target)
                    } else {
                        EventBus.emit('context:changed')
                        if (next) {
                            navigateToNext(this.$services, next).catch(err => {
                                displayErrors(err, this)
                                this.disabled = false
                            })
                        } else {
                            this.$router.replace({path: '/dashboard'})
                        }
                    }
                }
                displayErrors(resp, this)
                this.disabled = false
            }).catch(resp => {
                displayErrors(resp, this)
                this.disabled = false
            })
        },
    }
}
